export default "__VITE_ASSET__BJ8T_ioj__"